import { useIntl } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';
import type { Unit, Units } from './types';
import { Unit as StyledUnit } from './styles';

const capitalize = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const UnitPrice = ({ items }: Units) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  if (items === undefined) {
    return null;
  }
  return items
    .filter((unit: Unit) => unit.count > 0)
    .map((unit: Unit) => {
      const noun = unit.count === 1 ? unit.noun_singular : unit.noun_plural;
      const unitLabel = capitalize(noun);
      return (
        <StyledUnit
          key={`${unit.noun_singular}-${unit.count}`}
          className="unit"
        >
          {roundPrice(unit.unit_price_formatted)}&nbsp;
          {unit.per_tour === true
            ? formatMessage({
                defaultMessage: 'For',
                description: 'Separator for unit price and count',
              })
            : 'x'}
          &nbsp;
          {unit.count}&nbsp;
          {unitLabel}
        </StyledUnit>
      );
    });
};
